import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import gql from 'graphql-tag';

import { GetMarkets } from '../../athena/types/GetMarkets';
import { REGION_FIELDS } from '../../fragments/fence/region';

export const GET_MARKETS = gql`
  query GetMarkets {
    fence {
      getRegionsFromTags(input: { tagIdentifiers: ["market"], withDetail: true }) {
        regions {
          ...RegionFields
        }
      }
    }
  }
  ${REGION_FIELDS}
`;

const useGetMarkets = (options?: QueryHookOptions<GetMarkets>) =>
  useQuery<GetMarkets>(GET_MARKETS, options);

export default useGetMarkets;
